import gql from 'graphql-tag'

export const CONSULTANT_NOTIFICATION_EMAIL_ADDRESSES_UPDATE_MUTATION = gql`
    mutation consultantNotificationEmailAddressesUpdate(
        $consultantNotificationEmailAddresses: [ConsultantNotificationEmailAddressInput!]!
    ) {
        consultantNotificationEmailAddressesUpdate(
            consultantNotificationEmailAddresses: $consultantNotificationEmailAddresses
        ) {
            id
            email
            notificationEmitters
            created_at
            updated_at
        }
    }
`
